var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Service_Icon",
    "data-name": "Service Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 32,
    height: 32,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(1.313 3.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M24.457,19.046a1.182,1.182,0,0,0,.919.394,1.313,1.313,0,0,0,.919-.394l4.2-4.2a1.248,1.248,0,0,0,0-1.839l-1.97-2.036a2.43,2.43,0,0,0,.394-1.379A2.627,2.627,0,0,0,26.3,6.965a2.43,2.43,0,0,0-1.379.394l-2.036-1.97a1.248,1.248,0,0,0-1.839,0l-4.2,4.2a1.248,1.248,0,0,0,0,1.839l2.889,2.889L16.446,17.6,12.9,14.056a5.713,5.713,0,0,0,.919-3.152,5.91,5.91,0,0,0-5.91-5.91,1.313,1.313,0,1,0,0,2.627A3.283,3.283,0,1,1,4.627,10.9,1.313,1.313,0,1,0,2,10.9a5.91,5.91,0,0,0,5.91,5.91,5.713,5.713,0,0,0,3.152-.919l3.546,3.546L6.334,27.714a1.248,1.248,0,0,0,0,1.839,1.248,1.248,0,0,0,1.839,0l8.273-8.273,8.273,8.273a1.3,1.3,0,1,0,1.839-1.839L18.284,19.44l3.283-3.283ZM19.6,10.51l2.364-2.364,5.778,5.778-2.364,2.364Z",
    transform: "translate(-2 -4.985)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M308.9,7057.8l2.385-2.389,5.823,5.933-2.374,2.31Z",
    transform: "translate(-291.313 -7050.273)",
    fill: "#2666cf",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/service-icon.b38b2df6505045e5c2e37b374ba58dbc.svg";
export { ForwardRef as ReactComponent };